import cities from '~/data/fakeCities';

// Cities part
const citiesOptions = cities.map(c => {
  return {
    label: c.name,
    value: c.name,
  };
});
const selectedCity = cities.filter(c => c.selected)[0];
// End cities part

const filters = [
  {
    name: 'type',
    value: ['All'],
    type: 'select',
    isMulti: true,
    options: [{ label: 'Все типы', value: 'All' }],
    label: 'Тип программы',
  },
  {
    name: 'course',
    value: ['All'],
    type: 'select',
    isMulti: true,
    options: [{ label: 'Все курсы', value: 'All' }],
    label: 'Курс',
  },
  {
    name: 'cities',
    value: [selectedCity.name],
    type: 'select',
    isMulti: false,
    options: citiesOptions,
    label: 'Город',
  },
  {
    name: 'forwho',
    value: ['All'],
    type: 'select',
    isMulti: true,
    options: [{ label: 'Для всех', value: 'All' }],
    label: 'Для кого',
  },
  {
    name: 'dateFrom',
    value: new Date(),
    type: 'date',
    label: 'Искать с даты',
  },
  {
    name: 'online',
    value: ['Face-to-face','Online'],
    type: 'tags',
    options: [
      { label: 'Очные', value: 'Face-to-face' },
      { label: 'Онлайн', value: 'Online' },
      { label: 'Электронные курсы', value: 'Elearning' },
    ],
    label: 'Онлайн/очные',
  }
];

export default filters;
